import React, { useState, useEffect, useCallback } from 'react';
import CheckboxRenderer from './CheckboxRenderer';

const CustomCheckBoxCellRenderer = (props) => {
  const { data, disabledField, api, node } = props;

  const fieldValue = data[disabledField];
  const [checked, setChecked] = useState(fieldValue ? true : node.isSelected());
  const [disabled] = useState(fieldValue);

  const onSelectionChanged = useCallback(() => {
    // If disabled, always show as checked
    const fieldValue = data[disabledField];
    setChecked(fieldValue ? true : node.isSelected());
  }, [data, disabledField, node]);

  const handleChange = useCallback(
    (event, checked) => {
      // Only handle selection if not disabled
      if (!disabled) {
        node.setSelected(checked);
      }
    },
    [disabled, node]
  );

  useEffect(() => {
    api.addEventListener('selectionChanged', onSelectionChanged);

    return () => {
      api.removeEventListener('selectionChanged', onSelectionChanged);
    };
  }, [api, onSelectionChanged]);

  const checkboxValue = {
    checked,
    disabled,
    isIntermediate: false
  };

  return <CheckboxRenderer value={checkboxValue} onChange={handleChange} />;
};

export default CustomCheckBoxCellRenderer;
